import store from "../index";
import { connection } from "./hubConnection";

connection.on("UpdateMTAAppointment", (appointment) => {
  if (Boolean(appointment)) {
    store.commit("appointmentsModule/UPDATE_APPOINTMENT", appointment);
  }
});
